module.exports = "/fonts/segoe-ui-bold.ttf";